import Icon from 'veui/components/Icon'

Icon.register({
  rotate: {
    paths: [
      {
        d: 'M704 288H224a32 32 0 00-32 32v352a32 32 0 0032 32h480a32 32 0 0032-32V320a32 32 0 00-32-32zm-32 352H256V352h416zM301.62 133.13A256.19 256.19 0 0097 384a32 32 0 01-64 0A320 320 0 01353 64h31a32 32 0 0122.63 54.63l-96 96a32 32 0 01-45.26-45.26z'
      }
    ],
    width: '768',
    height: '768'
  }
})
